import { ButtonText, Icon } from "@visa/vds";
import React from "react";

const NewCertificationPackageBtn = ({ totalCount, setOpenNewCertificationPopup, setOpenSubscriptionWarningDialog, btnText="New Certification Package" }) => {

    const handleNewCertificationPackageBtnClick = (e) => {
        e.stopPropagation();
        if (totalCount < 6) {
            setOpenNewCertificationPopup(true)
        } else {
            setOpenSubscriptionWarningDialog(true);

        }
    }

    return (
        <ButtonText
            className="certification-package-btn"
            colorScheme="tertiary"
            onClick={(e) => handleNewCertificationPackageBtnClick(e)}
        ><Icon name="add" resolution="low" />{btnText}</ButtonText>
    )
}

export default NewCertificationPackageBtn;